import { render, staticRenderFns } from "./TitleAndDescription.vue?vue&type=template&id=095a1398"
import script from "./TitleAndDescription.vue?vue&type=script&lang=js"
export * from "./TitleAndDescription.vue?vue&type=script&lang=js"
import style0 from "./TitleAndDescription.vue?vue&type=style&index=0&id=095a1398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports